// extracted by mini-css-extract-plugin
export var bookletImage = "styles-module--bookletImage--32oZw";
export var button = "styles-module--button--Yxb_o";
export var buttonContainer = "styles-module--buttonContainer--hvul6";
export var careGuideDownload = "styles-module--careGuideDownload--3Fuyq";